import { v4 as uuidv4 } from 'uuid';
import { IPreferences, IWidgetRegistration } from "../types/interfaces";

const DASHBOARD_PAGE = "DASHBOARD_PAGE";

export function getValidatedConfig(widgetGrid: any, widget: any, config: any) {
    let alreadyExist = widgetGrid.find((ob: any) => ob?.config?.title?.trim().toLowerCase() === config?.title?.trim().toLowerCase() && widget?.uuid !== ob?.uuid)
    if (!alreadyExist) {
        return config;
    }
    let filteredNames = widgetGrid.filter((ob: any) => ob?.config?.title?.startsWith(config?.title?.trim()) && widget?.uuid !== ob?.uuid)
        .map((ob: any) => ob?.config?.title ? ob?.config?.title : ob.name);
    return { ...config, title: getNewName(filteredNames, config?.title?.trim()) };
}


export function getNewName(names: Array<string>, name: string): string {
    let numbers = names.map((oneName: string) => {
        //make sure regex variable is inside loop. JS Regex behaves differently
        let regex = new RegExp(`^${name}(\\s*\\d+)*$`, 'gi');
        let regexOutput = regex.exec(oneName);
        if (regexOutput && regexOutput[0] === oneName && regexOutput[1]) {
            try {
                let num = Number.parseInt(regexOutput[1].trim());
                return num;
            } catch (e) {
                console.error(e);
            }
        }
    }).filter(ob => ob !== undefined);
    if (numbers.length === 0 && names.includes(name)) {
        return name + ' ' + 1;
    }
    if (numbers.length > 0 && names.includes(name)) {
        // assuming max 100 widgets of one type at one page, which is highly not possible
        for (let i = 1; i < 100; i++) {
            if (!numbers.includes(i)) {
                name = name + ' ' + i;
                break;
            }
        }
    }
    return name;
}


export const mapPrefToRegistration = (pref: IPreferences.Preferences, widgetRegistration: Array<IWidgetRegistration.WidgetRegistration>): Array<IWidgetRegistration.WidgetRegistration> => {
    let dashboardConfig: Array<IPreferences.Card> = [];
    if (pref?.preferences?.pages) {
        let pages = pref?.preferences?.pages
        let dashboardPrefObject: IPreferences.Page | undefined = pages.find((page: IPreferences.Page) => page.name === DASHBOARD_PAGE);
        dashboardConfig = dashboardPrefObject?.cards || [];
    }
    let widgets: Array<IWidgetRegistration.WidgetRegistration> = [];
    if (dashboardConfig.length === 0) { //load default as there were no configs
        let defaultRegisters = widgetRegistration.filter((register: IWidgetRegistration.WidgetRegistration) => register.isDefault);
        widgets = defaultRegisters.map((register: IWidgetRegistration.WidgetRegistration) => {
            register.widgetProps.isConfigOpenAtMount = false;
            register.config = { title: register.name }
            register.uuid = uuidv4();
            return register;
        });
    } else {
        dashboardConfig.map((card: IPreferences.Card) => {
            let registerObj: IWidgetRegistration.WidgetRegistration | undefined = widgetRegistration.find((register: IWidgetRegistration.WidgetRegistration) => card.key === register.key);
            if (!registerObj) return null;
            widgets.push({ ...card, ...registerObj });
        });
    }
    return widgets;
}


export const updatePreferences = (widgetGrid: Array<IWidgetRegistration.WidgetRegistration>, pref: IPreferences.Preferences): IPreferences.Preferences => {
    let payload: Array<IPreferences.Card> = widgetGrid.map((widget: IWidgetRegistration.WidgetRegistration) => {
        let { key, uuid, name, config } = widget;
        return { key, uuid, name, config };
    });
    let dashboardPrefIndex: number = (pref.preferences.pages || []).findIndex((page: IPreferences.Page) => page.name === DASHBOARD_PAGE);
    if (dashboardPrefIndex !== -1 && pref.preferences.pages) {
        pref.preferences.pages[dashboardPrefIndex].cards = payload;
    } else {
        pref.preferences.pages = [{
            name: DASHBOARD_PAGE,
            cards: payload
        }];
    }
    return pref;
}